import LogoText from "src/SharedComponents/LogoText/LogoText";
import { IDistributorInfo } from "src/Utils/Hooks/useGetDistributorInfo/useGetDistributorInfo";
import MoreOptionsMenu from "../../MoreOptions/MoreOptions";
import { MailIcon, PhoneIcon, MapPinIcon } from "src/SharedComponents/Icons/Icons";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";

interface IPartnerInfoParams {
    partnerDetails: IDistributorInfo;
    onEditPartnerClick: () => void;
}

const PartnerInfo: React.FC<IPartnerInfoParams> = ({ partnerDetails, onEditPartnerClick }) => {
    const { t } = useTranslation();

    const address = useMemo(() => {
          const addressParts = [partnerDetails.streetAddress, partnerDetails.city, partnerDetails.zipCode, partnerDetails.country];
          return addressParts.filter(part => part).join(", ")
        }, [partnerDetails]);

    return (
        <>
            {/* Figma centres the 48px more-options circle on the partner-name
                row, so the row is centre-aligned and takes its height from the
                trigger instead of the old fixed 32px. */}
            <div className="row align-items-center">
                <div className="col-9">
                    <span className="ds-subheader">{partnerDetails?.name}</span>
                </div>
                <div className="col-3 d-flex justify-content-end">
                    <MoreOptionsMenu>
                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                            <li><div className="dropdown-item" key="1" id='edit-clinic-data' onClick={onEditPartnerClick} >{t('EditPartenerData')}</div></li>
                        </ul>
                    </MoreOptionsMenu>
                </div>
            </div>
            {partnerDetails?.email  && <LogoText logoElement={<MailIcon />} text={partnerDetails?.email} />}
            {partnerDetails?.contact && <LogoText logoElement={<PhoneIcon />} text={partnerDetails?.contact} /> }
            {address && <LogoText logoElement={<MapPinIcon />} text={address} />}

        </>
    )
}
export default PartnerInfo;
